module.exports = __webpack_public_path__ + "media/maps/directions-09d8ad72.svg";